import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';

const HomePage = () => {
  const { theme } = useTheme();

  return (
    <div 
      className="min-h-screen flex flex-col relative overflow-hidden"
      style={{ backgroundColor: theme.mainPanelBg }}
    >
      {/* Animated Background Overlay */}
      <div className="absolute inset-0 opacity-20 pointer-events-none" style={{ background: `radial-gradient(circle, ${theme.sidebarBg} 20%, transparent 80%)` }}></div>
      
      {/* Hero Section */}
      <div className="flex-1 flex flex-col items-center justify-center text-center p-6 relative z-10">
        <h1 
          className="text-5xl font-extrabold tracking-wide mb-4"
          style={{ color: theme.mainPanelText }}
        >
          Your Ideas, Your Space
        </h1>
        <p 
          className="text-lg max-w-xl mx-auto mb-6"
          style={{ color: theme.mainPanelText }}
        >
          Capture thoughts, organize knowledge, and bring your creativity to life with a seamless note-taking experience.
        </p>
        
        {/* CTA Buttons */}
        <div className="flex gap-6">
          <Link
            to="/login"
            className="px-6 py-3 rounded-lg font-semibold shadow-md transform hover:scale-105 transition-transform"
            style={{ backgroundColor: theme.buttonBg, color: theme.buttonText }}
          >
            Start Writing
          </Link>
          <Link
            to="/explore"
            className="px-6 py-3 rounded-lg font-semibold border border-solid hover:bg-opacity-20 transition-all"
            style={{ borderColor: theme.buttonBg, color: theme.mainPanelText }}
          >
            Discover Features
          </Link>
        </div>
      </div>
      
      {/* Feature Section */}
      <div 
        className="py-16 relative z-10"
        style={{ backgroundColor: theme.sidebarBg }}
      >
        <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 p-6">
          <FeatureCard 
            title="Effortless Organization"
            description="From quick notes to structured projects, categorize and retrieve everything with ease."
            theme={theme}
          />
          <FeatureCard 
            title="Seamless Collaboration"
            description="Work together in real-time, sharing thoughts and ideas instantly."
            theme={theme}
          />
          <FeatureCard 
            title="AI-Powered Assistance"
            description="Generate insights, summaries, and ideas with smart AI integration."
            theme={theme}
          />
        </div>
      </div>
    </div>
  );
};

// Feature Card Component
const FeatureCard = ({ title, description, theme }) => (
  <div 
    className="p-6 rounded-xl shadow-md hover:shadow-lg transition-all transform hover:-translate-y-1"
    style={{ backgroundColor: theme.mainPanelBg }}
  >
    <h3 
      className="text-2xl font-semibold mb-2"
      style={{ color: theme.mainPanelText }}
    >
      {title}
    </h3>
    <p
      className="text-base"
      style={{ color: theme.mainPanelText }}
    >
      {description}
    </p>
  </div>
);

export default HomePage;
